import { Box } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import { colorTokens } from "../../../../styles/globalStyles";
import { UnsubscribeIcon } from "../../../../styles/StyledMUI";
import { MAIL_UNSUBSCRIBE_CTA_LABEL } from "../mailUnsubscribeBlock";

export default function MailUnsubscribeBlockFields() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        minWidth: 0,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: colorTokens.bg.surfaceMuted,
          color: colorTokens.text.primary,
          flexShrink: 0,
        }}
        aria-hidden
      >
        <UnsubscribeIcon sx={{ fontSize: 22 }} />
      </Box>
      <DarkTypography level="body-md" colorVariant="primary">
        {MAIL_UNSUBSCRIBE_CTA_LABEL}
      </DarkTypography>
    </Box>
  );
}
